import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/right-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-7b28097e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "icon"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "right"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['item', { square: _ctx.square }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', _ctx.menuItem)))
  }, [
    (_ctx.menuItem.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.menuItem.icon,
            alt: _ctx.menuItem.name
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.menuItem.name), 1)
      ], true)
    ]),
    _hoisted_4
  ], 2))
}